import type {
  WidgetRpcActionType,
  WidgetSession as WidgetSessionFromNaptime,
} from 'bundles/naptimejs/resources/__generated__/OnDemandBoxViewAnnotationSessionsV1';

export type WidgetSessionId = string;
export const WidgetRpcAction = {
  SET_STORED_VALUES: 'SET_STORED_VALUES',
  GET_STORED_VALUES: 'GET_STORED_VALUES',
  SET_ANSWER: 'SET_ANSWER',
  SET_COMPLETE: 'SET_COMPLETE',
  SET_HEIGHT: 'SET_HEIGHT',
  READ_CUSTOM_QUERY_RESULTS: 'READ_CUSTOM_QUERY_RESULTS',
  GET_EXTERNAL_API_AUTHORIZATIONS: 'GET_EXTERNAL_API_AUTHORIZATIONS',
  GET_SESSION_CONFIGURATION: 'GET_SESSION_CONFIGURATION',
  GET_ACTIVITY_SUMMARIES: 'GET_ACTIVITY_SUMMARIES',
  SET_ITEM_COMPLETE: 'SET_ITEM_COMPLETE',
  SUBMIT_SURVEY_RESPONSE: 'SUBMIT_SURVEY_RESPONSE',
  GET_GROUP_MEMBERSHIPS: 'GET_GROUP_MEMBERSHIPS',
} as const;

export type WidgetRpcActionTypeFromEnum = typeof WidgetRpcAction[keyof typeof WidgetRpcAction];

export type WidgetSessionConfiguration = {
  custom?: any;
  storedValueConfiguration?: {
    [x: string]: any;
  };
  nostosReadAuthorizations?: {
    [x: string]: any;
  };
  externalApiConfigurations?: {
    [x: string]: any;
  };
};

export function isRpcAction(a: string): a is WidgetRpcActionType {
  return !!Object.keys(WidgetRpcAction).find((elem) => elem === a);
}

export type WidgetSession = WidgetSessionFromNaptime;

export type WidgetResponse = {
  session: WidgetSession;
  sessionId: WidgetSessionId;
};
